import { createContext } from "react";

interface DriverContextType {
  driverInstance: any | null;
  setDriverInstance: (driver: any) => void;
  isTourOpen: boolean;
  setIsTourOpen: (isOpen: boolean) => void;
  startTour: () => void;
  stopTour: () => void;
  nextStep: () => void;
  previousStep: () => void;
}

export const DriverContext = createContext<DriverContextType>({
  driverInstance: null,
  setDriverInstance: () => {},
  isTourOpen: false,
  setIsTourOpen: () => {},
  startTour: () => {},
  stopTour: () => {},
  nextStep: () => {},
  previousStep: () => {},
});
